/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ShiftReportItemType {
  None = 'None',
  Downtime = 'Downtime',
  ProductionOrder = 'ProductionOrder'
}
